import { useRouter } from 'next/router';

import { useViewTransition } from '@watershed/ui-core/hooks/useViewTransition';

/**
 * Hook that provides navigation with optional view transitions
 * Automatically uses view transitions when available, falls back to regular navigation
 */
export function useNavigateWithTransition() {
  const router = useRouter();
  const startViewTransition = useViewTransition();

  const navigate = async (targetRoute: string) => {
    if (startViewTransition) {
      startViewTransition(() => {
        void router.push(targetRoute);
      });
    } else {
      await router.push(targetRoute);
    }
  };

  return { navigate };
}
